const { debounce } = window.BAO.Utils

const KeenSlider = window.KeenSlider

const { setInitialised } = window.BAO.Carousel.plugins

class ProductCard extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()

    this.handleOptionKeydown = this.handleOptionKeydown.bind(this)
    this.listeners.add(this, 'keydown', this.handleOptionKeydown)

    if (
      this.els?.slide?.elements?.length < 2 ||
      this.dataset.carouselDisabledMobile === 'true'
    ) {
      return
    }

    this.initialiseCarousel = this.initialiseCarousel.bind(this)
    this.listeners.add(window, 'load', this.initialiseCarousel)

    this.onResize = this.onResize.bind(this)
    this.listeners.add(window, 'resize', debounce(this.onResize, 100))

    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.GRID_SWITCHER.SWITCHED_COLUMNS,
      this.reset.bind(this),
    )
  }

  connectedCallback () {
    super.connectedCallback()

    if (this.dataset.carouselDisabledMobile === 'true') return

    this.initialiseCarousel()
  }

  handleOptionKeydown (e) {
    if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return

    const options = this.els.option?.elements ?? []
    const currentIndex = options.indexOf(e.target)
    if (currentIndex === -1) return

    e.preventDefault()

    const offset = e.key === 'ArrowRight' ? 1 : -1
    const next =
      options[(currentIndex + offset + options.length) % options.length]

    e.target.setAttribute('tabindex', '-1')
    next.setAttribute('tabindex', '0')
    next.focus()
  }

  initialiseCarousel () {
    this.carousel = this.setupCarousel()
  }

  setupCarousel () {
    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        loop: true,
        mode: 'snap',
        rubberband: false,
        defaultAnimation: {
          duration: 800,
        },
        dragSpeed: 0.8,
        slides: {
          perView: 1,
        },
        breakpoints: {
          '(max-width: 900px)': {
            disabled: false,
          },
          '(min-width: 901px)': {
            disabled: true,
          },
        },
      },
      [setInitialised()],
    )
  }

  onResize () {
    this.reset()
  }

  reset () {
    if (this.carousel) {
      this.carousel.destroy()
    }

    this.carousel = this.setupCarousel()
  }
}

if (!customElements.get('product-card')) {
  customElements.define('product-card', ProductCard, {
    extends: 'article',
  })
}
